export default __webpack_public_path__ + "locales/lo-LA/Ldap.json?hash=181e780346642a9649cf779b65bc0d17";